import type { AxiosInstance } from 'axios';
import { Order, OrderList } from './types';
import { PaginateOptions } from '../types';

export class OrdersService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async list(options: PaginateOptions): Promise<OrderList> {
    const response = await this.instance.get<OrderList>('/orders', {
      params: options,
    });
    return response.data;
  }

  async getById({ id }: { id: number }): Promise<Order> {
    const response = await this.instance.get<Order>(`/orders/${id}`, {
      params: {
        dbOnly: false,
      },
    });
    return response.data;
  }
}
